import { takeLatest, call, put} from 'redux-saga/effects';

import { storage } from '../../firebase/firebase.utils';

import { fetchMusicSuccess, fetchMusicFailure} from './music.actions';

import { getDownloadPictureURL } from '../../firebase/firebase.utils';

import MusicActionTypes from './music.types';

export function* fetchMusicAsync() {
    try {
        const storageRef = storage.ref();
        const listRef = storageRef.child(`music`);
        const listAll = yield listRef.listAll();
        const getSong = yield call(getDownloadPictureURL, listAll);
        yield put(fetchMusicSuccess(getSong));
    } catch (error) {
        yield put(fetchMusicFailure(error.massage));
    }
}

export function* fetchMusicStart() {
    yield takeLatest(MusicActionTypes.FETCH_MUSIC_START, fetchMusicAsync);
}

